import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

//Services
import { InvoiceService } from '../../../../core/services/invoice.service';
import { AuthService } from 'src/app/core/services/auth.service';

//Models
import { Document } from 'src/app/models/invoice';
import { PendingDocument } from 'src/app/shared/models/pending-document.model';
import { TemplatesService } from 'src/app/core/services/templates.service';
import { Invoice } from 'src/app/models/invoice';
import { User } from '../../../../models/user';

//Enums
import * as enums from '../../../../shared/enums/tiposIncidencias.enum';

@Component({
  selector: 'app-preview-docs-user',
  templateUrl: './preview-docs-user.component.html',
  styleUrls: ['./preview-docs-user.component.scss']
})
export class PreviewDocsUserComponent implements OnInit {

  //Nuevos atributos.
  principal: string;
  secundario: string;
  mostrarError: boolean;
  currentUser: User;
  loading: boolean;
  loadingVerificar: boolean;
  loadingBorrar: boolean;
  loadingDevolucion: boolean;
  loadingSeparacion: boolean;
  loadingIncidencia: boolean;
  textoCabecera: string;
  textoEmpresaCabecera: string;
  totalDocumentos: number;
  totalEmitidas: number;
  totalRecibidas: number;
  listaDocumentos: PendingDocument[];
  tiposDeIncidencias: enums.TipoDeIncidencia[];
  documentoSeleccionado: Document;
  viewerConfig: any;
  numPagsDOCSEP = 0;
  esTercero: boolean = false;
  actualizadaPagina: number = 0;
  //filtros pantalla lista
  filtroUsuario: string;
  filtroFechaIni: string;
  filtroFechaFin: string;

  constructor(
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private authService: AuthService,
    private invoiceService: InvoiceService,
    private toastr: ToastrService
  ) {

    this.secundario = "";
    this.mostrarError = false;
    this.loading = false;
    this.loadingVerificar = false;
    this.loadingBorrar = false;
    this.loadingDevolucion = false;
    this.loadingDevolucion = false;
    this.loadingIncidencia = false;
    this.currentUser = this.authService.currentUserValue;

    this.documentoSeleccionado = null;
    this.actualizadaPagina = 0;
    this.tiposDeIncidencias = enums.TiposDeIncidenciasEnum;


    activatedRouter.params.subscribe(params => { this.secundario = params['id'] });

    const navigation = this.router.getCurrentNavigation();
    const state = navigation.extras.state as {
      principal: string,
      nombrePrincipal: string,
      secundario: string,
      nombreSecundario: string,
      totalRecibidas: string,
      totalEmitidas: string,
      total: string,
      fechaDocumento: number,
      horaDocumento: number,
      ///////filtro
      usuarioFiltro: string
      fechaIni: string,
      fechaFin: string
    };

    this.filtroUsuario = state.usuarioFiltro;
    this.filtroFechaIni = state.fechaIni;
    this.filtroFechaFin = state.fechaFin;

    this.principal = state.principal;

    if (state.nombrePrincipal != '' && state.nombreSecundario != '') {

      this.textoCabecera = `${state.principal} - ${state.nombrePrincipal} : ${state.secundario} - ${state.nombreSecundario}`;

    } else {

      this.textoCabecera = `${state.principal} : ${state.secundario}`;
    }

    this.invoiceService.ObtenerTerceros().subscribe(terceros => {
      console.log(terceros);

      var encontrado = terceros.findIndex(d => d.trim().toLowerCase() == state.principal.trim().toLowerCase());
      console.log(state.principal.toLowerCase());
      console.log(encontrado);

      if (encontrado == -1) {
        this.esTercero = false;
      } else {
        this.esTercero = true;
      }

      // this.esTercero = true;

      this.totalDocumentos = this.Valorar(state.total);
      this.totalEmitidas = this.Valorar(state.totalEmitidas);
      this.totalRecibidas = this.Valorar(state.totalRecibidas);

      this.viewerConfig = {
        btnClass: 'default', // The CSS class(es) that will apply to the buttons
        zoomFactor: 0.1, // The amount that the scale will be increased by
        containerBackgroundColor: '#ccc', // The color to use for the background. This can provided in hex, or rgb(a).
        wheelZoom: true, // If true, the mouse wheel can be used to zoom in
        allowFullscreen: false, // If true, the fullscreen button will be shown, allowing the user to entr fullscreen mode
        allowKeyboardNavigation: true, // If true, the left / right arrow keys can be used for navigation
        btnIcons: { // The icon classes that will apply to the buttons. By default, font-awesome is used.
          zoomIn: 'fa fa-plus',
          zoomOut: 'fa fa-minus',
          rotateClockwise: 'fa fa-repeat',
          rotateCounterClockwise: 'fa fa-undo',
          next: 'fa fa-arrow-right',
          prev: 'fa fa-arrow-left',
          fullscreen: 'fa fa-arrows-alt',
        },
        btnShow: {
          zoomIn: true,
          zoomOut: true,
          rotateClockwise: false,
          rotateCounterClockwise: false,
          next: false,
          prev: false
        }
      };

      this.invoiceService.obtenerDatosCabeceraInit(state.secundario, state.principal)
        .subscribe(resultado => {

          if (resultado.nombreEmpresa != '') {

            this.textoEmpresaCabecera = resultado.cifEmpresa + " - " + resultado.nombreEmpresa;

          } else {

            this.textoEmpresaCabecera = resultado.cifEmpresa;
          }
        }, error => {
          console.log(error);
        });

    }, error => {
      console.log("Error al obtener el listado de terceros actual");
      console.log(error);
    });
  }

  ngOnInit() {

    this.numPagsDOCSEP = 0;

    this.CargarDetalleDocumentos(this.principal, this.secundario);
  }

  CargarDetalleDocumentos(principal: string, secundario: string) {

    //SE COMPROBARA SI EL INVOICER ESTA EN MANTENIMIENTO.
    //Si es asi, se forzara un cierre de sesion antes de cargar un documento.
    this.authService.ObtenerEstadoMantenimiento().subscribe(enMantenimiento => {

      if (enMantenimiento == true) {
        //Se cierra sesion...

        const userId: string = this.authService.currentUserValue.email;

        this.authService.QuitarDocumentosAsignados(userId).subscribe(quitado => {
          this.authService.Logout();
          this.toastr.info("El Invoicer esta en mantenimiento. Espere un momento a que vuelva a estar habilitado.");
          this.router.navigate(['/Login']);
        }, error => {
          console.log(error);
        });

      } else {

        this.loading = true;
        this.listaDocumentos = [];

        this.invoiceService.ObtenerDetalleDocumentos(principal, secundario, this.GetFechaInteger(this.filtroFechaIni), this.GetFechaInteger(this.filtroFechaFin)).subscribe(datosRecibidos => {

          //Redirigir al listado inicial...
          if (datosRecibidos.length == 0 || datosRecibidos == null) {

            this.toastr.error("No se han encontrado datos para este secundario. Recargando listado inicial...");
            this.volverAlista();
            return;
          }

          this.listaDocumentos = datosRecibidos;
          this.loading = false;

          this.listaDocumentos.forEach(element => {

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //Si el numero de páginas viene NULL de la tabla, se iguala a 0 y se llama a servicio para comprobar el numero de paginas del documento...
            if (element.numeroPaginas == null) {

              this.invoiceService.ObtenerNumeroPaginas(element.idDoc).subscribe(paginas => {
                element.numeroPaginas = paginas;
              }, error => {
                this.toastr.error("Error en la comprobación del número de páginas")
                console.log(error);
              });
            }
          });

          this.listaDocumentos.forEach(element => {
            if (element.nifConPlantilla == true) {
              if (element.numeroFactura != "") {

                this.invoiceService.EsFacturaDuplicada(secundario, element.tipoDocumento, element.nifDocumento, element.numeroFactura, element.idDoc, 0)
                  .subscribe(existe => {

                    element.documentoDuplicado = existe;

                  }, error => {
                    this.toastr.error("Error al comprobar facturas duplicadas")
                    console.log(error);
                  });
              }
            }
          });

          console.warn("Listado documentos INICIAL: ");
          console.log(this.listaDocumentos);

        }, (error) => {
          console.log(error);
          this.loading = false;
          this.mostrarError = true;
        });
      }

    }, error => {
      console.log(error);
    });
  }

  GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

  volverAlista() {

    const navigationExtras: NavigationExtras = {
      state: {
        //////filtros
        usuarioFiltro: this.filtroUsuario,
        fechaIni: this.filtroFechaIni,
        fechaFin: this.filtroFechaFin
      }
    };

    this.router.navigate(['/Preview'], navigationExtras);
  }

  separarPaginas(doc: number) {

    $("#valorIDdoc").val(doc);
    const botonModal = document.getElementById("botonIdSeparar") as HTMLElement;
    botonModal.click();
  }

  confirmarSeparado() {

    var valorId: any = $("#valorIDdoc").val();
    var valorFINAL: number = this.Valorar(valorId);
    this.loadingSeparacion = true;

    this.invoiceService.SepararDocumento(valorFINAL).subscribe(resultado => {

      if (resultado) {
        this.toastr.info("Se ha separado el documento correctamente...");
      } else {
        this.toastr.error("Error al separar el documento seleccionado manualmente");
      }

      this.loadingSeparacion = false;
      this.cerrarModalSEP();
      this.CargarDetalleDocumentos(this.principal, this.secundario);

    }, (error) => {
      this.toastr.error("Error al separar el documento seleccionado manualmente");
      this.loadingSeparacion = false;
      this.cerrarModalSEP();
      this.CargarDetalleDocumentos(this.principal, this.secundario);
      console.warn(error);
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  borrarDocumento(doc: number) {

    $("#valorIDdoc").val(doc);

    const botonModal = document.getElementById("botonIdBorrar") as HTMLElement;
    botonModal.click();
  }

  confirmarBorrado() {

    let valorId: any = $("#valorIDdoc").val();

    var valorFINAL = this.Valorar(valorId);

    if (valorFINAL == 0) {
      this.toastr.error("No se puede eliminar el documento.");

      const botonCerrarModal = document.getElementById("cerrarAvisoDEL") as HTMLElement;
      botonCerrarModal.click();
    }

    this.loadingBorrar = true;

    this.invoiceService.BorraDocumento(valorFINAL).subscribe(resultado => {
      this.loadingBorrar = false;

      if (resultado == true) {

        this.toastr.info("Documento con ID ==> " + valorFINAL + " eliminado con éxito.");

        this.QuitarDocumentoDePreview(valorFINAL);

        const botonCerrarModal = document.getElementById("cerrarAvisoDEL") as HTMLElement;
        botonCerrarModal.click();

        if (this.listaDocumentos.length == 0) {
          this.volverAlista();
        }

      } else {
        this.toastr.error("No se puede eliminar el documento.");
      }
    }, (error) => {
      console.log(error);
      this.loadingBorrar = false;
      this.toastr.error("No se puede eliminar el documento.");
    });
  }

  devolverDoc(doc: number) {

    $("#valorIDdoc").val(doc);

    const botonModal = document.getElementById("botonIdDevolver") as HTMLElement;
    botonModal.click();
  }

  confirmarDevolucion() {

    var valorId: any = $("#valorIDdoc").val();
    var valorFINAL = this.Valorar(valorId);

    if (valorFINAL == 0) {
      this.toastr.error("No se puede devolver el documento.");

      const botonCerrarModal = document.getElementById("cerrarAvisoDEVO") as HTMLElement;
      botonCerrarModal.click();
    }

    this.loadingDevolucion = true;

    this.invoiceService.DevolverDocumento(valorFINAL).subscribe(resultado => {
      this.loadingDevolucion = false;

      if (resultado == false) {
        this.toastr.error("No se puede devolver el documento.");
        return;
      }

      this.toastr.info("Documento con ID ==> " + valorFINAL + " devuelto con éxito.");

      this.QuitarDocumentoDePreview(valorFINAL);

      const botonCerrarModal = document.getElementById("cerrarAvisoDEVO") as HTMLElement;
      botonCerrarModal.click();

      if (this.listaDocumentos.length == 0) {
        this.volverAlista();
      }

    }, (error) => {
      this.loadingBorrar
      this.toastr.error("No se puede devolver el documento.");
    });
  }

  PrevisualizarDocumento(idDocumento: number) {
    console.log("Visualizando documento: " + idDocumento);

    this.documentoSeleccionado = null;

    this.invoiceService.CargarDoc(idDocumento).subscribe(resultado => {
      this.documentoSeleccionado = resultado;
      this.actualizadaPagina = resultado.numberOfPages;

      /////////////////////
      //comprobamos si el documento cargado es un .tiff para así avisar de NO MARCAR COMO INCIDENCIA y pasar a revisión
      /////////////////////
      if (this.documentoSeleccionado.url.includes(".tif") == true || this.documentoSeleccionado.url.includes(".tiff") == true) {

        const botn_avisoTIFF = document.getElementById("botonAvisoTIFF") as HTMLElement;
        botn_avisoTIFF.click();
      }
    });

    const botonModal = document.getElementById("botonModalPreviewDocumento") as HTMLElement;
    botonModal.click();
  }

  cerrarPrevisualizacionDOC() {
    const botonModalCerrar = document.getElementById("cerradoModalPreview") as HTMLElement;
    botonModalCerrar.click();
  }

  preguntarSeparadoPreview() {

    this.cerrarPrevisualizacionDOC();

    this.separarPaginas(this.documentoSeleccionado.id);
  }

  preguntarBorradoPreview() {

    this.cerrarPrevisualizacionDOC();

    this.borrarDocumento(this.documentoSeleccionado.id);
  }

  preguntarDevolucionPreview() {

    this.cerrarPrevisualizacionDOC();

    this.devolverDoc(this.documentoSeleccionado.id);
  }

  cerrarModalSEP() {
    do {

      var botonModalCerrar: HTMLElement = document.getElementById("cerrarAvisoSEP") as HTMLElement;

    } while (botonModalCerrar == undefined || botonModalCerrar == null);

    botonModalCerrar.click();
  }

  VerificarDocumentos(tipoDocumento: number, todos: boolean, nifDocumento: string = "") {
    this.loadingVerificar = true;

    let listaDocumentosVerificar = this.listaDocumentos.filter(l => l.tipoDocumento == tipoDocumento);

    if (todos == false) {
      listaDocumentosVerificar = listaDocumentosVerificar.filter(l => l.nifDocumento == nifDocumento);
    }

    let listaIDs: Array<number> = [];

    listaDocumentosVerificar.forEach(element => {
      listaIDs.push(element.idDoc);
    });

    this.invoiceService.MarcarComoDisponibles(listaIDs).subscribe(resultado => {
      this.loadingVerificar = false;

      if (resultado == true) {
        this.toastr.success("Se han pasado a introducción los documentos con éxito");

        //Restar de los contadores totales y parciales.
        this.totalDocumentos = this.totalDocumentos - listaIDs.length;

        if (tipoDocumento == 1) {
          this.totalEmitidas = this.totalEmitidas - listaIDs.length;
        }
        else {
          this.totalRecibidas = this.totalRecibidas - listaIDs.length;
        }

        //filtrar los documentos pendientes
        if (todos == true) {
          this.listaDocumentos = this.listaDocumentos.filter(l => l.tipoDocumento == ((tipoDocumento == 1) ? 2 : 1))
        }
        else {
          listaIDs.forEach(element => {
            let indice = this.listaDocumentos.map(function (e) { return e.idDoc; }).indexOf(element)
            if (indice > -1) {
              this.listaDocumentos.splice(indice, 1);
            }
          });
        }

      } else {
        this.toastr.error("ERROR: Alguno de los documentos no se ha podido pasar a introducción");
      }

      this.invoiceService.ObtenerDetalleDocumentos(this.principal, this.secundario, this.GetFechaInteger(this.filtroFechaIni), this.GetFechaInteger(this.filtroFechaFin)).subscribe(datosRecibidos => {

        //Redirigir al listado inicial...
        if (datosRecibidos.length == 0 || datosRecibidos == null) {

          this.toastr.error("No se han encontrado datos para este secundario. Recargando listado inicial...");
          this.volverAlista();
          return;
        }

      }, error => {
        console.log(error);
      });

    }, (error) => {
      console.log(error);
      this.loadingVerificar = false;
      this.toastr.error("Error: No se han podido pasar a introducción los documentos");
    });
  }

  VerificarDocumentoIndividual() {
    this.cerrarPrevisualizacionDOC();

    this.VerificarDocumento(this.documentoSeleccionado.id);
  }

  VerificarDocumento(id: number) {
    this.loadingVerificar = true;

    let index = this.listaDocumentos.map(function (e) { return e.idDoc }).indexOf(id);

    if (index < 0) {
      this.toastr.error("No se ha podido pasar a introducción el documento");
      this.loadingVerificar = false;
      return;
    }

    let tipoDocumento = this.listaDocumentos[index].tipoDocumento;

    let listaIDs: Array<number> = [];
    listaIDs.push(id);

    this.invoiceService.MarcarComoDisponibles(listaIDs).subscribe(resultado => {
      this.loadingVerificar = false;

      if (resultado == true) {
        this.toastr.success("Se ha pasado a introducción el documento con éxito");

        //Restar de los contadores totales y parciales.
        this.totalDocumentos = this.totalDocumentos - listaIDs.length;
        if (tipoDocumento == 1) {
          this.totalEmitidas = this.totalEmitidas - listaIDs.length;
        }
        else {
          this.totalRecibidas = this.totalRecibidas - listaIDs.length;
        }

        //filtrar los documentos pendientes
        listaIDs.forEach(element => {
          let indice = this.listaDocumentos.map(function (e) { return e.idDoc; }).indexOf(element);
          if (indice > -1) {
            this.listaDocumentos.splice(indice, 1);
          }
        });
      } else {
        this.toastr.error("ERROR: No se ha podido pasar a introducción el documento");
      }

      this.invoiceService.ObtenerDetalleDocumentos(this.principal, this.secundario, this.GetFechaInteger(this.filtroFechaIni), this.GetFechaInteger(this.filtroFechaFin)).subscribe(datosRecibidos => {

        //Redirigir al listado inicial...
        if (datosRecibidos.length == 0 || datosRecibidos == null) {

          this.toastr.error("No se han encontrado datos para este secundario. Recargando listado inicial...");
          this.volverAlista();
          return;
        }

      }, error => {
        console.log(error);
      });

    }, (error) => {
      console.log(error);
      this.loadingVerificar = false;
      this.toastr.error("ERROR: No se ha podido pasar a introducción el documento");
    });
  }

  CargarRoutingPlantillas(tipoDoc: number, nifoSecundario: string) {
    // this.router.navigate(['/Templates/', nifoSecundario]);
    // var cadena: string = (this.documento.tipoDocumento == 1) ? this.document.secundario : this.formulario.get('invoiceCIF').value;
    // var tipo: number = this.document.tipoDocumento;

    var quieroPlantilla: any = {
      nifSecundario: nifoSecundario,
      tipo: tipoDoc
    };

    this.router.navigate(['/Templates/', quieroPlantilla]);
  }

  private Valorar(texto: string): number {
    if (isNaN(Number(texto)) == false) {
      return Number(texto);
    }

    return 0;
  }

  RegistrarIncidencia(opcion: number, areaTextoOpcionOtros: string) {

    this.loadingIncidencia = true;

    let dato: any = {};

    this.tiposDeIncidencias.forEach(element => {
      if (element.id == opcion) {
        dato = element;
      }
    });

    if (!dato) {
      return;
    }

    let textoIncidencia = dato.value;

    if (dato.id == 7) {
      textoIncidencia = areaTextoOpcionOtros;
    }

    //Se guarda factura como procesada y se guarda la incidencia...
    let invoice: Invoice = new Invoice();

    invoice.id = this.documentoSeleccionado.id;
    invoice.idTipoIncidencia = dato.idInterno;
    invoice.observaciones = textoIncidencia;
    invoice.numeroFactura = "";
    invoice.observacionesSUPER = "";
    invoice.nif = "";
    invoice.idUsuario = this.currentUser.id;
    invoice.fecha = 0;
    invoice.nombre = "";
    invoice.nombreComercial = "";
    invoice.direccion = "";
    invoice.telefono = "";
    invoice.poblacion = "";
    invoice.provincia = "";
    invoice.pais = "";
    invoice.codigoPais = "";
    invoice.codigoPostal = 0;
    invoice.totalFactura = 0;
    invoice.baseImponible1 = 0;
    invoice.porIva1 = 0;
    invoice.cuotaIva1 = 0;
    invoice.baseImponible2 = 0;
    invoice.porIva2 = 0;
    invoice.cuotaIva2 = 0;
    invoice.baseImponible3 = 0;
    invoice.porIva3 = 0;
    invoice.cuotaIva3 = 0;
    invoice.baseImponible4 = 0;
    invoice.porIva4 = 0;
    invoice.cuotaIva4 = 0;
    invoice.baseImponible5 = 0;
    invoice.porIva5 = 0;
    invoice.cuotaIva5 = 0;
    invoice.porRecargo1 = 0;
    invoice.cuotaRecargo1 = 0;
    invoice.porRecargo2 = 0;
    invoice.cuotaRecargo2 = 0;
    invoice.porRecargo3 = 0;
    invoice.cuotaRecargo3 = 0;
    invoice.porRecargo4 = 0;
    invoice.cuotaRecargo4 = 0;
    invoice.porRecargo5 = 0;
    invoice.cuotaRecargo5 = 0;
    invoice.baseRetencion = 0;
    invoice.porRetencion = 0;
    invoice.cuotaRetencion = 0;
    invoice.tipoRetencion = 0;
    invoice.tiempo = 0;
    invoice.tipoFactura = 0;
    invoice.suplidos = 0;
    invoice.noDesgloseIva = false;
    invoice.noDatosCP = false;
    invoice.email = "";

    this.invoiceService.postInvoice(invoice, "").subscribe(invoice => {

      this.loadingIncidencia = false;

      this.toastr.success('Incidencia del documento con ID ' + invoice.id + ' grabada con éxito.');

      this.QuitarDocumentoDePreview(this.documentoSeleccionado.id);
      this.cerrarPrevisualizacionDOC();
    }, (error) => {
      this.loadingIncidencia = false;
      this.toastr.error(error);
    });
  }

  private QuitarDocumentoDePreview(id: number) {

    let indice = this.listaDocumentos.map(function (e) { return e.idDoc; }).indexOf(id)

    if (indice > -1) {

      if (this.listaDocumentos[indice].tipoDocumento == 1) {
        this.totalEmitidas = this.totalEmitidas - 1;
      }
      else {
        this.totalRecibidas = this.totalRecibidas - 1;
      }

      this.totalDocumentos = this.totalDocumentos - 1;

      this.listaDocumentos.splice(indice, 1);

      //Si el listado está vacio después de actualizar, reedirigir al listado incial...
      if (this.listaDocumentos.length == 0) {
        this.toastr.info("No quedan mas documentos del secundario. Recargando listado inicial...")
        this.volverAlista();
      }
    }
  }

  edicionPaginas($event) {
    console.log(this.documentoSeleccionado.id);
    console.log(this.actualizadaPagina);

    this.invoiceService.alterarPaginasDoc(this.documentoSeleccionado.id, this.actualizadaPagina).subscribe(async resultado => {
      this.actualizadaPagina = 0;

      if (resultado) {
        this.toastr.success("Numero de páginas actualizado");

        this.cerrarPrevisualizacionDOC();
        await this.delay(2000);
        this.PrevisualizarDocumento(this.documentoSeleccionado.id);

      } else {
        this.toastr.error("No se ha podido actualizar el numero de páginas");
        this.actualizadaPagina = this.documentoSeleccionado.numberOfPages;
      }

    }, error => {
      this.toastr.error("No se ha podido actualizar el numero de páginas");
      this.actualizadaPagina = this.documentoSeleccionado.numberOfPages;
      console.log(error);
    });

  }

}
